<!--  -->
<template>
  <!-- <div class='recruit'> -->

  <!-- <div class="crumbs">
      <div class='content'>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item>加入我们</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div> -->
  <page pageDataUrl="/api/pageData/page_recruit"
        v-on:paddingData="paddingPageData"
        :hasbreadcrumbs="true"
        defPageTitle='加入我们'>

    <div class='content'>
      <h1 class="entry-title">加入我们</h1>
      <div class="recruit-info"
           v-html="r">
      </div>
      <p style="font-weight:bold;padding:  0 15px;font-size: 95%;margin: 20px 0 0 0;">
        招聘职位
      </p>
      <el-table :data="rs"
                style="width: 100%; padding:  0 15px">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div v-html="props.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column label="职位"
                         prop="recruitName"
                         align="center">
        </el-table-column>
        <el-table-column label="部门"
                         prop="recruitDepartment"
                         align="center">
        </el-table-column>
        <el-table-column label="人数"
                         width="50"
                         prop="count"
                         align="center">
        </el-table-column>
        <el-table-column label="工作地点"
                         prop="wordAddress"
                         align="center">
        </el-table-column>
        <!-- <el-table-column label="e-mail" prop="workingPlace" align="center">
          </el-table-column> -->
        <!-- <el-table-column label="状态" width="60" prop="isClose" align="center">
          </el-table-column> -->
        <el-table-column label="发布时间"
                         prop="updateTime"
                         align="center">
        </el-table-column>
      </el-table>

    </div>
  </page>
  <!-- </div> -->
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      r: "",
      rs: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    paddingPageData(data) {
      this.rs = data.data.rs;
      this.r = data.data.r;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // var that = this;
    // this.$request.get({
    //   url: "/api/pageData/page_recruit",
    //   callback: {
    //     success: function (data) {
    //       that.rs = data.data.rs;
    //       that.r = data.data.r;
    //     },
    //     err: function (err) {
    //       console.log(err);
    //     }
    //   }
    // });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.recruit-info {
  padding: 0 15px;
  font-size: 96%;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>